import React from 'react';
import { AccordionField } from '@gift/ui/components/accordion/partials/AccordionField';

export const PrefabPickerField = ({ onClick, active, title }: Props) => (
    <AccordionField onClick={onClick} active={active}>
        {title}
    </AccordionField>
);

type Props = {
    title: string,
    onClick: () => void,
    active: boolean,
};